export const environment = {
    extensionId: 'fgaidlbgjgeghedbcjlkjokkalnekdek',
};
